import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import store from './store'


Vue.config.productionTip = false

let app = ''

var firebaseConfig = {
  apiKey: "AIzaSyDXyv_jRhYoZgC8drR3T-iyLM2P5ZzNuN8",
  authDomain: "jesuisbenevole-101d7.firebaseapp.com",
  databaseURL: "https://jesuisbenevole-101d7.firebaseio.com",
  projectId: "jesuisbenevole-101d7",
  storageBucket: "jesuisbenevole-101d7.appspot.com",
  messagingSenderId: "390471337109",
  appId: "1:390471337109:web:6f25a7402147c73f5e479c",
  languageCode: "fr"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// Get a reference to the database service
export const db = firebase.firestore();

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      vuetify,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
